import { get, flow, filter, map, pick, set, values, reject } from 'lodash/fp';
import { connect } from 'react-redux';
import globalError from '../../../actions/globalError';
import InstallationOptions from './InstallationOptions';

const mapStateToProps = ({ estimateBuilder }, { designId }) => {
  const containerIds = get(`entities.estimates.byId.${designId}.containers`, estimateBuilder);

  const reduxContainers = flow(
    get('entities.containers.byId'),
    pick(containerIds),
    values,
    reject('isDeleted'),
  )(estimateBuilder);

  const reduxItems = flow(
    get('entities.items.byId'),
    filter({ isDeleted: false }),
  )(estimateBuilder);

  const containers = map(flow(
    pick(['charLabel', 'name', 'containerId']),
    (room) => {
      const items = flow(
        filter({ containerId: room.containerId }),
        map(pick(['itemId', 'label'])),
        map(set('isSelected', false)),
      )(reduxItems);

      return set('items', items, room);
    },
  ), reduxContainers);

  return {
    containers,
  };
};

const mapDispatchToProps = dispatch => ({
  globalError: err => dispatch(globalError({ err })),
});

export default connect(mapStateToProps, mapDispatchToProps)(InstallationOptions);
